import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { Booking, HoldBooking } from "../../../Types/UnitFeatureTypes";


interface DeleteBookingRequestState {
  request: {
    loading: boolean;
    success: boolean;
    error: string | null;
  };
}

export enum Types {
  DELETE_BOOKING_REQUEST = 'DELETE_BOOKING_REQUEST',
  DELETE_BOOKING_SUCCESS = 'DELETE_BOOKING_SUCCESS',
  DELETE_BOOKING_FAILURE = 'DELETE_BOOKING_FAILURE',
  DELETE_BOOKING_HOLD_REQUEST = 'DELETE_BOOKING_HOLD_REQUEST',
  DELETE_BOOKING_HOLD_SUCCESS = 'DELETE_BOOKING_HOLD_SUCCESS',
  DELETE_BOOKING_HOLD_FAILURE = 'DELETE_BOOKING_HOLD_FAILURE',
}

const deleteBookingHoldRequestAction = createAsyncAction(
  Types.DELETE_BOOKING_HOLD_REQUEST,
  Types.DELETE_BOOKING_HOLD_SUCCESS,
  Types.DELETE_BOOKING_HOLD_FAILURE,
)
<
  { id: number },
  { success: boolean },
  { message: string }
>();

const deleteBookingRequestAction = createAsyncAction(
  Types.DELETE_BOOKING_REQUEST,
  Types.DELETE_BOOKING_SUCCESS,
  Types.DELETE_BOOKING_FAILURE,
)
<
  { id: number },
  { success: boolean },
  { message: string }
>();

export const Actions = { deleteBookingHoldRequestAction, deleteBookingRequestAction };

export const initialState: DeleteBookingRequestState = {
  request: {
    loading: false,
    error: null as string | null,
    success: false,
  }
};

export type DeleteBookingRequestInfoState = typeof initialState;

const deleteBookingHoldRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.success = false;
    draft.request.error = null;
  });

const deleteBookingHoldSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.deleteBookingHoldRequestAction.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.success = true;
    if (draft.request.success) {
      draft.request.loading = false;
    }
  });

const deleteBookingHoldFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.deleteBookingHoldRequestAction.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.success = false;
    draft.request.error = payload.message;
  });

const deleteBookingRequestRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.success = false;
    draft.request.error = null;

    return draft;
  });

const deleteBookingRequestSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.deleteBookingRequestAction.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.success = payload.success;
    if (draft.request.success) {
      draft.request.loading = false;
    }

    return draft;
  });

const deleteBookingRequestFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.deleteBookingRequestAction.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.success = false;
    draft.request.error = payload.message;

    return draft;
  });

export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.deleteBookingRequestAction.request, deleteBookingRequestRequest)
  .handleAction(Actions.deleteBookingRequestAction.success, deleteBookingRequestSuccess)
  .handleAction(Actions.deleteBookingRequestAction.failure, deleteBookingRequestFailure)
  .handleAction(Actions.deleteBookingHoldRequestAction.request, deleteBookingHoldRequest)
  .handleAction(Actions.deleteBookingHoldRequestAction.success, deleteBookingHoldSuccess)
  .handleAction(Actions.deleteBookingHoldRequestAction.failure, deleteBookingHoldFailure);
  